import { render, staticRenderFns } from "./MomentCreateComponent.vue?vue&type=template&id=276a9aec&scoped=true&"
import script from "./MomentCreateComponent.vue?vue&type=script&lang=js&"
export * from "./MomentCreateComponent.vue?vue&type=script&lang=js&"
import style0 from "./MomentCreateComponent.vue?vue&type=style&index=0&id=276a9aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a9aec",
  null
  
)

export default component.exports